import css from './Loader.module.scss'

export const Loader = () => {
  return <div className={css.loader}>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
}
